module.exports = __webpack_public_path__ + "img/olympique-marseille-logo-icon.9274f5a2.png";